import { render } from "./SellersListView.vue?vue&type=template&id=1f185787"
import script from "./SellersListView.vue?vue&type=script&lang=js"
export * from "./SellersListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__